// extracted by mini-css-extract-plugin
module.exports = {"card":"BestPlaceToCode_card__3PiXK","image":"BestPlaceToCode_image__2T5oA"};